import { LineChart, PageHead } from "@getaways/extranet-ui";
import { useCan } from "../lib/access";
import { FilterBar, useFilters, useOptions } from "../lib/filters";
import { eur } from "../lib/format";
import { compactEur, filterOf, ResultTable, useQuery } from "../lib/query";

/** Who sold what (docs/36 §7): per agent and team, channel, package and market. Agents see their own line only. */
export function SalesPage() {
  const can = useCan();
  const money = can("money:read");
  const [filters, setFilters] = useFilters("sales");
  const options = useOptions();
  const f = filterOf(filters);
  const m = ["orders", "pax", "sell", "avg_order", ...(money ? ["margin", "margin_pct"] : [])];
  const daily = useQuery({ table: "orders", measures: ["sell", "orders"], dimensions: ["booked_day"], filter: filterOf({ ...filters, basis: "booked" }), sort: "booked_day", dir: "asc", limit: 400 });
  const rows = daily.data?.rows ?? [];
  return (
    <>
      <PageHead title="Sales" sub={can("sales:all") ? "Every agent and channel." : can("sales:team") ? "Your teams' agents." : "Your own sales."} />
      <div className="card" style={{ padding: 0, marginBottom: 14 }}>
        <FilterBar filters={filters} onChange={setFilters} options={options} supplierFilter={false} />
      </div>
      {rows.length > 1 && (
        <section className="card" style={{ marginBottom: 14 }}>
          <h2 style={{ marginTop: 0, fontSize: 15 }}>Sold per day</h2>
          <LineChart label="Sold per booking day" categories={rows.map((r) => String(r.booked_day).slice(5))} categoryTitle={(i) => String(rows[i]!.booked_day)} format={(v) => eur(v)} axisFormat={compactEur} height={200} series={[{ label: "Sold", color: "var(--series-2)", values: rows.map((r) => Number(r.sell ?? 0)) }]} />
        </section>
      )}
      <div className="grid-2">
        <ResultTable title="By agent" spec={{ table: "orders", measures: m, dimensions: ["agent"], filter: f }} label={(c, v) => (c === "agent" && v === null ? "Site (no agent)" : undefined)} />
        <ResultTable title="By channel" spec={{ table: "orders", measures: m, dimensions: ["source", "sales_channel"], filter: f }} label={(c, v) => (c === "source" && v === null ? "storefront" : undefined)} />
        <ResultTable title="By package" spec={{ table: "orders", measures: m, dimensions: ["product"], filter: f, limit: 30 }} label={(c, v) => (c === "product" && v === null ? "Tailor-made / not from the Desk" : undefined)} />
        <ResultTable title="By market" spec={{ table: "orders", measures: m, dimensions: ["market"], filter: f }} />
        <ResultTable title="By payment plan" spec={{ table: "orders", measures: ["orders", "sell"], dimensions: ["plan"], filter: f }} />
        <ResultTable title="Legacy and platform" spec={{ table: "orders", measures: ["orders", "sell"], dimensions: ["origin"], filter: f }} />
      </div>
    </>
  );
}
